import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess3026Status: 'idle',
    startProcess3026Error: undefined as any,
    loadUserParamsProcess3026Status: 'idle',
    loadUserParamsProcess3026Error: undefined as any,

    process3026List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess3026 = createAsyncThunk('process3026Slice/startProcess3026', async ({ process3026 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess3026/`,
        prepareData(process3026),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess3026Status } = getState().process3026Slice
        return startProcess3026Status !== 'pending'
    }
})

export const loadUserParamsProcess3026 = createAsyncThunk('process3026Slice/loadUserParamsProcess3026', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess3026/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess3026Status } = getState().process3026Slice
        return loadUserParamsProcess3026Status !== 'pending'
    }
})

const Process3026Slice = createSlice({
    name: 'process3026Slice',
    initialState,
    reducers: {
        resetstartProcess3026: (state) => {
            state.job = undefined
            state.startProcess3026Error = undefined
        },
        resetstartProcess3026Error: (state) => {
            state.startProcess3026Error = undefined
        },
        resetloadUserParamsProcess3026: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess3026Error = undefined
        },
        resetloadUserParamsProcess3026Error: (state) => {
            state.loadUserParamsProcess3026Error = undefined
        },
        removeFromProcess3026ListById: (state, action) => {
            state.process3026List = state.process3026List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess3026ListByIds: (state, action) => {
            state.process3026List = state.process3026List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process3026List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess3026Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process3026List = []
            state.startProcess3026Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess3026.pending, (state) => {
            state.startProcess3026Status = 'pending'
            state.startProcess3026Error = undefined
        })
        builder.addCase(startProcess3026.fulfilled, (state, action) => {
            state.startProcess3026Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess3026.rejected, (state, action) => {
            state.startProcess3026Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess3026Error = action.error.message
            } else {
                state.startProcess3026Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess3026.pending, (state) => {
            state.loadUserParamsProcess3026Status = 'pending'
            state.loadUserParamsProcess3026Error = undefined
        })
        builder.addCase(loadUserParamsProcess3026.fulfilled, (state, action) => {
            state.loadUserParamsProcess3026Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess3026.rejected, (state, action) => {
            state.loadUserParamsProcess3026Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess3026Error = action.error.message
            } else {
                state.loadUserParamsProcess3026Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess3026,
    resetstartProcess3026Error,
    resetloadUserParamsProcess3026,
    resetloadUserParamsProcess3026Error,
    removeFromProcess3026ListById,
    removeFromProcess3026ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process3026Slice.actions
export default Process3026Slice.reducer
